import {DatePipe}                           from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {VapeRecordLogIntf}                  from '@djsharkk/logr-types';
import {TableRowBase}                       from '../table-row-base';
import {TableRow}                           from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-vape',
			   imports    : [
				   DatePipe
			   ],
			   templateUrl: './table-row-vape.component.html',
			   styleUrl   : './table-row-vape.component.css'
		   })
export class TableRowVapeComponent extends TableRowBase<VapeRecordLogIntf> {
	row = input.required<TableRow>();
	showDate = input(false, {transform: booleanAttribute});
	detailed = input(false, {transform: booleanAttribute});
}
